import { TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MomentModule } from 'ngx-moment';

import { RtiIntegrationsModule } from '@recruitee/integrations';
import { PhoneNumberPipe } from '@recruitee/user-interface';

@NgModule({
  imports: [MomentModule, RouterModule, RtiIntegrationsModule, TitleCasePipe],
  exports: [],
  providers: [PhoneNumberPipe],
})
export class CandidatesTableModule {}
